import React, { useEffect, useState } from 'react';
import { AnimatePresence } from 'framer-motion';
import { useLocation } from 'react-router-dom';
import AppRoutes from './Routes';
import ScrollToTop from './Components/ScrollToTop';
import Footer from './Components/Footer';
import Header from './Components/Header';
import UseScrollToTop from './hooks/useScrollToTop';
import Mobilenavbar from './Components/Header/MobileHeader';
import { useNetworkError } from './hooks/context/NetworkErrorContext';
import NoInternetPage from './pages/NoInternetPage';
import "react-toastify/dist/ReactToastify.css";
import "../src/assets/css/introduction.css"
import "../src/assets/css/methods.css"

function App() {
  const location = useLocation();
  const { internetError, setInternetError } = useNetworkError(); // Using the context
  const [internetConnError, setInternetConnError] = useState(false);

  useEffect(() => {
    const checkInternetConnection = async () => {
      setInternetConnError(navigator.onLine === true ? false : true);
      setInternetError(navigator.onLine === true ? false : true);
    };

    checkInternetConnection();

    const handleOnlineStatusChange = () => {
      checkInternetConnection();
    };

    window.addEventListener('online', handleOnlineStatusChange);
    window.addEventListener('offline', handleOnlineStatusChange);

    return () => {
      window.removeEventListener('online', handleOnlineStatusChange);
      window.removeEventListener('offline', handleOnlineStatusChange);
    };
  }, []);

  // Check if the current route matches '/404'
  const notFound = location.pathname.startsWith('/404');

  // Check if the current route matches '/maintenece_mode'
  const mainteneceMode = location.pathname.startsWith('/maintenece_mode');

  // Check if the current route matches '/merchant_policy'
  const merchant_policy = location.pathname.startsWith('/merchant_policy');

  // Check if the current route matches '/merchant_terms_conditions'
  const merchant_terms_conditions = location.pathname.startsWith('/merchant_terms_conditions');

  // Check if the current route matches '/merchant_security'
  const merchant_security = location.pathname.startsWith('/merchant_security');

  // Check if the current route matches '/customer_policy'
  const customer_policy = location.pathname.startsWith('/customer_policy');

  // Check if the current route matches '/customer_terms_conditions'
  const customer_terms_conditions = location.pathname.startsWith('/customer_terms_conditions');

  // Check if the current route matches '/customer_security'
  const customer_security = location.pathname.startsWith('/customer_security');

  // Check if the current route matches '/wl_policy'
  const wl_policy = location.pathname.startsWith('/wl_policy');

  // Check if the current route matches '/wl_terms_conditions'
  const wl_terms_conditions = location.pathname.startsWith('/wl_terms_conditions');

  // Check if the current route matches '/wl_security'
  const wl_security = location.pathname.startsWith('/wl_security');

  // Check if the current route matches '/developer-portal'
  const developer_documents = location.pathname.startsWith('/developer-portal');

  return (
    <>
      {internetError || internetConnError ? (
        <NoInternetPage internetConnError={internetConnError || internetError} />
      ) : (
        <div className="w-full transition duration-300">
          <AnimatePresence>
            {(!wl_security && !developer_documents && !wl_policy && !wl_terms_conditions && !customer_security && !customer_terms_conditions && !customer_policy && !merchant_security && !merchant_terms_conditions && !merchant_policy && !mainteneceMode && !notFound) && <Header key={"uniqueKey1"} />}
            {(!wl_security && !developer_documents && !wl_policy && !wl_terms_conditions && !customer_security && !customer_terms_conditions && !customer_policy && !merchant_security && !merchant_terms_conditions && !merchant_policy && !mainteneceMode && !notFound) && <Mobilenavbar key={"uniqueKey6"} />}
            <AppRoutes key={"uniqueKey2"} />
            {(!wl_security && !developer_documents && !wl_policy && !wl_terms_conditions && !customer_security && !customer_terms_conditions && !customer_policy && !merchant_security && !merchant_terms_conditions && !merchant_policy && !mainteneceMode && !notFound) && <Footer key={"uniqueKey3"} />}
            <UseScrollToTop key={"uniqueKey4"} />
            <ScrollToTop key={"uniqueKey5"} />
          </AnimatePresence>
        </div>
      )}
    </>
  );
}

export default App;
